import React, { Component } from 'react';
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import { PropTypes as PT } from 'prop-types';
import Fuse from 'fuse.js';
import Scroll from 'react-scroll';
import _map from 'lodash/map';
import _findIndex from 'lodash/findIndex';
import browserInfo, { getQueryParams } from '../../utils/browserUtils';
import DeviceListItem from '../DeviceListItem';
import './DeviceList.css';

const scroll = Scroll.animateScroll;
const ELEMENT_HEIGHT = 50;
const fuseSearchOptions = {
  shouldSort: true,
  threshold: 0.3,
  location: 0,
  distance: 255,
  maxPatternLength: 64,
  keys: [
    'description',
    'serial'
  ]
};

const DEVICE_REBOOTING_TIMEOUT = 10000;

const messages = defineMessages({
  searchDevices: {
    id: 'searchDevices',
    defaultMessage: 'Search for your room'
  },
  search: {
    id: 'search',
    defaultMessage: 'Search'
  },
  deviceRebooting: {
    id: 'deviceRebooting',
    defaultMessage: '{deviceName} is rebooting.'
  }
});

class DeviceList extends Component {
  constructor(props) {
    super(props);
    let preFilteredDevice = getQueryParams().device || '';

    if (preFilteredDevice) {
      preFilteredDevice = decodeURI(preFilteredDevice);
    }

    this.state = {
      filterString: preFilteredDevice,
      apiError: null,
      deviceApiCalled: false,
    };
  }

  componentWillMount() {
    window.addEventListener('keydown', this.onKeyDown);
    if (this.state.filterString) {
      this.props.setNotification(
          this.props.intl.formatMessage(
              messages.deviceRebooting, { deviceName: this.state.filterString }
          ), DEVICE_REBOOTING_TIMEOUT
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.scrollToContact && nextProps.scrollToContact !== this.props.scrollToContact) {
      const index = _findIndex(
        nextProps.contacts, contact => contact.serial === nextProps.scrollToContact.serial
      );
      if (index) {
        scroll.scrollTo(index * ELEMENT_HEIGHT, {
          duration: 150,
          smooth: true,
          containerId: 'deviceScrollBox',
          isDynamic: true,
          ignoreCancelEvents: true
        });
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKeyDown);
  }

  onKeyDown = (evt) => {
    const ck = evt.keyCode ? evt.keyCode : evt.which;
    if ((evt.ctrlKey || event.metaKey) && ck === 70 && this.searchInput) {
      evt.preventDefault();
      this.searchInput.focus();
    }
  };

  render() {
    const {
      contacts,
      intl,
      isadmin,
      removeDeviceFromList,
      setNotification
    } = this.props;

    let filteredContacts = contacts;
    if (this.state.filterString.length) {
      const fuse = new Fuse(contacts, fuseSearchOptions);
      filteredContacts = fuse.search(this.state.filterString);
    }

    const renderBody = () => {
      if (this.state.showSettings) {
        return ('Settings');
      }

      if (filteredContacts.length) {
        return (
          <div className="deviceScrollBox" id="deviceScrollBox">
            {_map(filteredContacts, contact => (
              <DeviceListItem
                contact={contact}
                isadmin={isadmin}
                removeDeviceFromList={removeDeviceFromList}
                setNotification={setNotification}
              />
            ))}
          </div>
        )
      }

      return (
        <div className="contactRow solo" style={{ width: '100%' }}>
          <FormattedMessage
            id="notFound"
            defaultMessage="No results found."
          />
        </div>
      );
    };

    return (
      <div className="deviceListContainer">
        <div className="listHeader">
          <h2 className="deviceTitle">
            <FormattedMessage
              id="selectDevice"
              defaultMessage="Select a device to start screen sharing"
            />
          </h2>
          <div className="searchBox">
            <div className="icon icon-search deviceSearch" />
            <input
              ref={(elt) => { this.searchInput = elt; }}
              placeholder={browserInfo.isMobile ?
                intl.formatMessage(messages.search)
                :
                intl.formatMessage(messages.searchDevices)
              }
              className="searchInput"
              defaultValue={this.state.filterString}
              onChange={(evt) => {
                this.setState({ filterString: evt.target.value });
              }}
            />
            {!!this.state.filterString.length && <button
              className="icon icon-cancel endDeviceSearch"
              onClick={() => {
                this.searchInput.value = '';
                this.setState({ filterString: '' });
                this.searchInput.focus();
              }}
            />}
          </div>
        </div>
        {renderBody()}
      </div>
    );
  }
}

DeviceList.propTypes = {
  intl: PT.object,
  contacts: PT.array,
  isadmin: PT.bool,
  removeDeviceFromList: PT.func,
  setNotification: PT.func,
  scrollToContact: PT.object
};

export default injectIntl(DeviceList);



// WEBPACK FOOTER //
// ./src/components/DeviceList/DeviceList.js